module.exports = __webpack_public_path__ + "static/img/car_new_mg5.a9d8d45c.png";